// Garde-fous PWA iOS (désactive pinch/gestures en mode standalone)
if (typeof window !== 'undefined') {
  const isStandalone =
    window.matchMedia?.('(display-mode: standalone)')?.matches ||
    window.navigator?.standalone === true;

  if (isStandalone) {
    document.addEventListener(
      'touchmove',
      (e) => {
        if (e.touches && e.touches.length > 1) e.preventDefault();
      },
      { passive: false }
    );

    document.addEventListener('gesturestart', (e) => e.preventDefault());
    document.addEventListener('gesturechange', (e) => e.preventDefault());
    document.addEventListener('gestureend', (e) => e.preventDefault());

    // iOS: cache la barre en scrollant légèrement
    window.scrollTo(0, 1);
  }
}
